import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function LevelSelect({ value, onValueChange, testIdPrefix }) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="w-48" data-testid={`${testIdPrefix}-level-select`}>
        <SelectValue placeholder="Уровень сложности" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="beginner" data-testid={`${testIdPrefix}-level-beginner`}>Начальный</SelectItem>
        <SelectItem value="intermediate" data-testid={`${testIdPrefix}-level-intermediate`}>Средний</SelectItem>
        <SelectItem value="advanced" data-testid={`${testIdPrefix}-level-advanced`}>Продвинутый</SelectItem>
      </SelectContent>
    </Select>
  );
}
